import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    aparatoSistema: [],
  },

  getters: {
    getAparatoSistema: (state) => state.aparatoSistema,

    getInterrogatorio: (state) => {
      const interrogatorio = [];

      state.aparatoSistema.forEach((aparato) => {
        interrogatorio.push({
          fk_idCatAparatoSistema: aparato.id,
          diagnostico: '',
        });
      });

      return interrogatorio;
    },
  },

  mutations: {
    SET_APARATO_SISTEMA(state, aparatoSistema) {
      state.aparatoSistema = aparatoSistema;
    },
  },

  actions: {
    async fetchAparatoSistema({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catAparatoSistema')
        .then((response) => {
          commit('SET_APARATO_SISTEMA', response.data.data);
        });
    },
  },
};
